import React from 'react'
import IcomoonReact from 'icomoon-react'
import classNames from 'classnames'
import rebrandIconList from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import agendaStyles from '../../agendaStyles.module.scss'

// itemId: String/Integer
// updateRating: Method
// rating: Integer
const StarRating = ({ itemId, updateRating, rating, refId }) => {
  return (
    <div
      className={classNames(
        generalStyles.flexRow,
        generalStyles.flexAround,
        generalStyles.mt20,
        generalStyles.mb40
      )}
    >
      {[...Array(5)].map((x, i) => {
        i++
        return (
          <button
            key={`star-${itemId}-${i}`}
            data-testid={`star-${refId}-${i}`}
            onClick={() => {
              // If updateRating function is provided, call it with the new rating and itemId
              if (typeof updateRating === 'function') {
                updateRating(i, itemId)
              }
            }}
            className={agendaStyles.starBtn}
          >
            <IcomoonReact
              size={24}
              iconSet={rebrandIconList}
              color={rating >= i ? variables.c01lightBase0000d3 : variables.c01lightBase0000d3}
              icon={
                rating >= i
                  ? 'Controls-RatingFull'
                  : 'Controls-RatingOutline'
              }
            />
          </button>
        )
      })}
    </div>
  )
}

export default StarRating
